// Passive Events Patch for jQuery/Slick
// Prefers passive touch listeners for scroll performance, but MUST NOT override
// an explicit { passive: false } — WeTheme's body-scroll-lock (and similar iOS
// Safari scroll locks) need non-passive touchmove so preventDefault / unlock
// can run. Forcing passive:true there leaves body/html overflow:hidden stuck.
//
// A page-wide { passive: false } touchmove listener is how iOS Safari scroll
// locks work (preventDefault on touchmove blocks scrolling; overflow:hidden
// alone does not reliably stop iOS rubber-band scroll). Upnova attaches the
// same pattern, and if its close/empty-cart path skips removeEventListener,
// the page stays tappable but frozen. Record those global listeners and expose
// window.__CLNF_releaseGlobalTouchLocks() so clnf-cart-drawer-guard.js can
// drop them after independently confirming no drawer is open.

(function () {
  'use strict';

  var originalAddEventListener = EventTarget.prototype.addEventListener;
  var originalRemoveEventListener = EventTarget.prototype.removeEventListener;
  var globalTouchMoveLocks = [];

  function isGlobalTarget(target) {
    return (
      target === document ||
      target === document.documentElement ||
      target === document.body ||
      target === window
    );
  }

  function optionsCapture(options) {
    if (typeof options === 'boolean') return options;
    if (options && typeof options === 'object') return !!options.capture;
    return false;
  }

  EventTarget.prototype.addEventListener = function (type, listener, options) {
    if (!this || typeof this.addEventListener !== 'function') {
      return;
    }

    if (
      type === 'touchstart' ||
      type === 'touchmove' ||
      type === 'touchend' ||
      type === 'touchcancel'
    ) {
      if (typeof options === 'boolean') {
        options = { capture: options, passive: true };
      } else if (typeof options === 'object' && options !== null) {
        if (options.passive !== false) {
          options = Object.assign({}, options, { passive: true });
        }
      } else {
        options = { passive: true };
      }

      if (type === 'touchmove' && options.passive === false && listener && isGlobalTarget(this)) {
        globalTouchMoveLocks.push({
          target: this,
          listener: listener,
          capture: optionsCapture(options)
        });
      }
    }

    return originalAddEventListener.call(this, type, listener, options);
  };

  EventTarget.prototype.removeEventListener = function (type, listener, options) {
    if (type === 'touchmove' && globalTouchMoveLocks.length && isGlobalTarget(this)) {
      var capture = optionsCapture(options);
      globalTouchMoveLocks = globalTouchMoveLocks.filter(function (entry) {
        return !(entry.target === this && entry.listener === listener && entry.capture === capture);
      }, this);
    }
    return originalRemoveEventListener.call(this, type, listener, options);
  };

  window.__CLNF_releaseGlobalTouchLocks = function () {
    if (!globalTouchMoveLocks.length) return;
    var pending = globalTouchMoveLocks;
    globalTouchMoveLocks = [];
    pending.forEach(function (entry) {
      try {
        originalRemoveEventListener.call(entry.target, 'touchmove', entry.listener, entry.capture);
      } catch (e) {}
    });
  };

  // Note: jQuery's own `.on()` calls the native addEventListener per event
  // type internally, so the patch above already makes jQuery-bound touch
  // listeners passive too - no separate jQuery.fn.on patch is needed. (A
  // previous version of this file added one, but it rebuilt combined event
  // strings like "mouseover touchstart focusin" by keeping only the type(s)
  // containing "touch" and silently dropped the rest, breaking hover/focus
  // dropdown menus - see theme.min.js's `this.$parents.on("mouseover
  // touchstart focusin", ...)` call.)
})();
